// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface StudentEdit
 */
export interface StudentEdit {
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    gender?: StudentEditGenderEnum;
    /**
     * 
     * @type {Date}
     * @memberof StudentEdit
     */
    birthday?: Date;
    /**
     * Additional metadata
     * @type {object}
     * @memberof StudentEdit
     */
    metadata?: object;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentEdit
     */
    photoId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudentEdit
     */
    contractorIds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum StudentEditGenderEnum {
    Male = 'male',
    Female = 'female'
}



